import { useMemo } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"
import { useGetOrderReviewQuery } from "shared/redux/endpoints/procurementApprovals"
import { useGetProcurementCentersQuery } from "shared/redux/endpoints/procurementItems"
import {
  OrderLinesSection,
  VendorProposalsSection,
  LinkedPurchasesSection,
  ApprovalProgressSection,
} from "../approvals/ManagerOrderSections"
import StatusBadge from "../StatusBadge"
import { formatVND } from "../../constants"

const OrderDetailModal = ({ orderId, onClose }) => {
  const { data: order, isLoading } = useGetOrderReviewQuery(orderId, { skip: !orderId })
  const { data: centersPage } = useGetProcurementCentersQuery({ size: 200 })
  const centerNameById = useMemo(() => {
    const map = {}
    ;(centersPage?.items || []).forEach((c) => {
      if (c.centerId != null) map[c.centerId] = c.centerName
    })
    return map
  }, [centersPage])

  return (
    <Dialog open={!!orderId} onClose={onClose} fullWidth maxWidth="lg" scroll="paper">
      <DialogTitle>
        <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <MDTypography variant="h5">{order?.orCode || "Order"}</MDTypography>
          {order && <StatusBadge status={order.status} />}
        </MDBox>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading || !order ? (
          <MDTypography variant="body2" color="text">
            Loading…
          </MDTypography>
        ) : (
          <>
            <MDTypography variant="button" fontWeight="medium" display="block">
              {order.title}
            </MDTypography>
            {order.reason && (
              <MDTypography variant="body2" color="text" mt={0.5}>
                {order.reason}
              </MDTypography>
            )}
            <MDTypography variant="button" fontWeight="bold" display="block" mt={1} mb={2}>
              Total: {formatVND(order.total)}
            </MDTypography>
            <OrderLinesSection lines={order.lines} centerNameById={centerNameById} />
            <VendorProposalsSection proposals={order.vendorProposals} lines={order.lines} sourceId={order.id} />
            <LinkedPurchasesSection purchases={order.purchases} />
            <ApprovalProgressSection steps={order.approvalProgress} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <MDButton variant="outlined" color="dark" onClick={onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  )
}

export default OrderDetailModal
